import { useNavigate, useParams } from 'react-router-dom';
import { Card, Table, Row, Col, Badge } from 'react-bootstrap';
import moment from 'moment';
import { useViewVisitorSingleInvoice } from '../apiEndpoints/VisitorApiEndpoints';
import { IoIosArrowBack } from 'react-icons/io';
import { Link } from 'react-router-dom';
import { encodeData } from '../../../Components/Common/utility/commonUtility';
import InvoicePayment from '../../Exhibitor/Profile/Invoice/InvoicePayment';
import CommonOnlinePayment from '../../Common/Payment/CommonOnlinePayment';

const ViewVisitorSingleBilling = () => {
  const { id } = useParams();
  const { data } = useViewVisitorSingleInvoice(id!);
  const navigate = useNavigate();
  return (
    <Card className='shadow-sm border-0'>
      <Card.Header className='text-white' style={{ background: '#4c5263' }}>
        <div className='d-flex justify-content-between align-items-center'>
          <h4 className='mb-0'>Invoice Details</h4>
          <div
            onClick={() => navigate('/visitor/invoice')}
            className='d-flex align-items-center gap-1 pointer'
            style={{
              border: '1px solid gray',
              color: 'white',
              padding: '5px 7px',
              borderRadius: '5px',
            }}
          >
            <IoIosArrowBack />
            <p>Back</p>
          </div>
        </div>
      </Card.Header>
      <Card.Body>
        <Row className='mb-4'>
          <Col md={6}>
            <h5 className='text-muted'>General Information</h5>
            <dl className='row'>
              <div className='row align-items-start'>
                <dt className='col-sm-4 text-start d-flex justify-content-between'>
                  <span>Invoice No.</span>
                  <span>:</span>
                </dt>
                <dd className='col-sm-8 text-start'>
                  {data?.data?.invoice_no}
                </dd>
              </div>

              <div className='row  align-items-start'>
                <dt className='col-sm-4 text-start d-flex justify-content-between'>
                  <span>Invoice Date</span>
                  <span>:</span>
                </dt>
                <dd className='col-sm-8 text-start'>
                  {moment(data?.data?.invoice_date).format('DD-MMM-YYYY')}
                </dd>
              </div>

              <div className='row  align-items-start'>
                <dt className='col-sm-4 text-start d-flex justify-content-between'>
                  <span>Due Date</span>
                  <span>:</span>
                </dt>
                <dd className='col-sm-8 text-start'>
                  {moment(data?.data?.due_date).format('DD-MMM-YYYY') || 'N/A'}
                </dd>
              </div>
            </dl>
          </Col>

          <Col md={6}>
            <h5 className='text-muted'>Financial Summary</h5>
            <dl className='row'>
              <div className='row align-items-start'>
                <dt className='col-sm-4 text-start d-flex justify-content-between'>
                  <span>Sub Total</span>
                  <span>:</span>
                </dt>
                <dd className='col-sm-8 text-start'>{data?.data?.sub_total}</dd>
              </div>
              <div className='row align-items-start'>
                <dt className='col-sm-4 text-start d-flex justify-content-between'>
                  <span>Net Total</span>
                  <span>:</span>
                </dt>
                <dd className='col-sm-8 text-start'>
                  <Badge bg='success' text='white'>
                    {data?.data?.net_total}
                  </Badge>
                </dd>
              </div>
              <div className='row align-items-start'>
                <dt className='col-sm-4 text-start d-flex justify-content-between'>
                  <span>Client Payment</span>
                  <span>:</span>
                </dt>
                <dd className='col-sm-8 text-start'>
                  <Badge bg='success' text='white'>
                    {data?.data?.clientPayment}
                  </Badge>
                </dd>
              </div>

              <div className='row align-items-start'>
                <dt className='col-sm-4 text-start d-flex justify-content-between'>
                  <span>Due</span>
                  <span>:</span>
                </dt>
                <dd className='col-sm-8 text-start'>
                  <Badge
                    bg={Number(data?.data?.due) > 0 ? 'danger' : 'success'}
                    text='white'
                  >
                    {data?.data?.due}
                  </Badge>
                </dd>
              </div>
              <div className='row align-items-start'>
                <dt className='col-sm-4 text-start d-flex justify-content-between'>
                  <span>VAT</span>
                  <span>:</span>
                </dt>
                <dd className='col-sm-8 text-start'>{data?.data?.vat}</dd>
              </div>

              <div className='row align-items-start'>
                <dt className='col-sm-4 text-start d-flex justify-content-between'>
                  <span>Discount</span>
                  <span>:</span>
                </dt>
                <dd className='col-sm-8 text-start'>{data?.data?.discount}</dd>
              </div>

              <div
                className='row align-items-start'
                style={{
                  fontSize: '12px',
                  cursor: 'pointer',
                  marginRight: '3px',
                  width: '100%',
                  maxWidth: '250px',
                }}
              >
                {' '}
                <CommonOnlinePayment
                  invoiceId={data?.data?.id}
                  userId={data?.data?.visitor_id}
                  userType={'Visitor'}
                  isPaid={
                    Number(data?.data?.due) <= 0 ||
                    data?.data?.status === 'Paid'
                      ? 'Paid'
                      : undefined
                  }
                />
              </div>

              {/* {Number(data?.data?.due) > 0 && (
                <div className='row align-items-start'>
                  <Link
                    to={`/visitor/payment-management?value=${encodeData({
                      amount: data?.data?.due,
                      invoice_id: data?.data.id,
                      isVisitor: true,
                    })}`}
                  >
                    <Badge
                      bg={'primary'}
                      text={'light'}
                      style={{
                        fontSize: '12px',
                        cursor: 'pointer',
                        marginRight: '3px',
                        width: '100%',
                        maxWidth: '250px',
                      }}
                    >
                      Pay Now
                    </Badge>
                  </Link>
                </div>
              )} */}
            </dl>
          </Col>
        </Row>
        <hr />
        <h5 className='text-primary'>Invoice Items</h5>
        <Table striped bordered hover className='mt-3'>
          <thead className='bg-light'>
            <tr>
              <th>SL.</th>
              <th>Description</th>
              <th>Product Name</th>
              <th>Quantity</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {data?.data?.invoice_items?.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.description}</td>
                <td>{item.product_name}</td>
                <td>{item.quantity}</td>
                <td>{Number(item.amount) * Number(item.quantity) || 0}</td>
              </tr>
            ))}
          </tbody>
        </Table>

        {Boolean(data?.data?.invoicePayment?.length) && (
          <InvoicePayment PaymentRecord={data?.data?.invoicePayment} />
        )}
      </Card.Body>
    </Card>
  );
};

export default ViewVisitorSingleBilling;
